import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import NewsletterCTA from "./NewsletterCTA";
import { isAnalyticsEnabled, toggleAnalytics } from "@/utils/analytics";
import { useToast } from "@/hooks/use-toast";
const Footer = ({
  className
}: {
  className?: string;
}) => {
  const [analyticsEnabled, setAnalyticsEnabled] = useState(true);
  const {
    toast
  } = useToast();
  useEffect(() => {
    setAnalyticsEnabled(isAnalyticsEnabled());
  }, []);
  const handleToggleAnalytics = () => {
    toggleAnalytics();
    const newStatus = !analyticsEnabled;
    setAnalyticsEnabled(newStatus);
    toast({
      title: newStatus ? "Analytics aktiviert" : "Analytics deaktiviert",
      description: newStatus ? "Deine Besuche werden jetzt wieder getrackt" : "Deine Besuche werden nicht mehr getrackt",
      duration: 3000
    });
  };
  return <footer className={className || "bg-gray-950/60 backdrop-blur-sm border-t border-border"}>
      {/* Newsletter Section */}
      <div className="border-b border-border">
        <NewsletterCTA variant="inline" className="bg-neutral-900" />
      </div>
      
      <div className="container mx-auto max-w-6xl px-4 py-12 bg-stone-950">
        {/* Logo */}
        <div className="mb-8 text-center">
          <img src="/logo.png" alt="praxis-versichert.de Logo" className="h-12 w-auto mx-auto mb-3" />
        </div>

        {/* Navigation Links */}
        <nav className="mb-8">
          <ul className="flex flex-wrap justify-center gap-x-4 sm:gap-x-6 lg:gap-x-8 gap-y-2 sm:gap-y-3 text-xs sm:text-sm">
            <li>
              <Link to="/" className="text-muted-foreground hover:text-accent transition-colors">
                Home
              </Link>
            </li>
            <li>
              <Link to="/cyberrisiken" className="text-muted-foreground hover:text-accent transition-colors">
                Cyber-Risiken
              </Link>
            </li>
            <li>
              <Link to="/tarifwissen" className="text-muted-foreground hover:text-accent transition-colors">
                Tarifwissen
              </Link>
            </li>
            <li>
              <Link to="/weitere-versicherungen" className="text-muted-foreground hover:text-accent transition-colors">
                Weitere Versicherungen
              </Link>
            </li>
            <li>
              <Link to="/faq" className="text-muted-foreground hover:text-accent transition-colors">
                FAQ
              </Link>
            </li>
            <li>
              <Link to="/termin-buchen" className="text-muted-foreground hover:text-accent transition-colors">
                Termin buchen
              </Link>
            </li>
            <li>
              <Link to="/ueber-uns" className="text-muted-foreground hover:text-accent transition-colors">
                Über uns
              </Link>
            </li>
            <li>
              <Link to="/team" className="text-muted-foreground hover:text-accent transition-colors">
                Team
              </Link>
            </li>
          </ul>
        </nav>

        {/* Legal Links */}
        <div className="mb-8">
          <ul className="flex flex-wrap justify-center gap-x-8 gap-y-2 text-xs">
            <li>
              <Link to="/newsletter" className="text-muted-foreground hover:text-accent transition-colors">
                Newsletter
              </Link>
            </li>
            <li>
              <Link to="/impressum" className="text-muted-foreground hover:text-accent transition-colors">
                Impressum
              </Link>
            </li>
            <li>
              <Link to="/datenschutz" className="text-muted-foreground hover:text-accent transition-colors">
                Datenschutz
              </Link>
            </li>
            <li>
              <Link to="/erstinformation" className="text-muted-foreground hover:text-accent transition-colors">
                Erstinformation
              </Link>
            </li>
            <li>
              <Link to="/sitemap" className="text-muted-foreground hover:text-accent transition-colors">
                Sitemap
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Info with HTML5 Microdata */}
        <div className="mb-8 text-center text-sm" itemScope itemType="https://schema.org/Person">
          <meta itemProp="name" content="Thomas Dewein" />
          <meta itemProp="jobTitle" content="Versicherungsmakler" />
          
          <a href="tel:01636389945" itemProp="telephone" className="text-accent hover:text-accent/80 transition-colors font-medium text-sm sm:text-base inline-flex items-center gap-2">
            📞 0163 638 99 45
          </a>
          
          <link itemProp="url" href="https://praxis-versichert.de" />
        </div>

        {/* Copyright */}
        <div className="pt-8 border-t border-border/50 text-center">
          <p className="text-xs text-muted-foreground">
            © 2025 praxis-versichert.de – Alle Rechte vorbehalten
          </p>
        </div>
      </div>

      {/* Analytics Toggle Button - Fixed position */}
      <button onClick={handleToggleAnalytics} className="fixed bottom-4 right-4 opacity-20 hover:opacity-100 transition-opacity p-3 rounded-full bg-muted/80 backdrop-blur-sm text-xl shadow-lg z-50" title={analyticsEnabled ? "Analytics deaktivieren" : "Analytics aktivieren"} aria-label={analyticsEnabled ? "Analytics deaktivieren" : "Analytics aktivieren"}>
        {analyticsEnabled ? "📊" : "🚫"}
      </button>
    </footer>;
};
export default Footer;